/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nz-table[_ngcontent-%COMP%]{margin-top:-5px}[_nghost-%COMP%]     nz-table.main-table table{border-spacing:0 10px}[_nghost-%COMP%]     thead tr:hover>*{background-color:#fff!important}[_nghost-%COMP%]     tbody tr:hover>*{background-color:#fff!important}.empty-cart-container[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{margin-bottom:5px}.empty-cart-container[_ngcontent-%COMP%]   .empty-cart-description[_ngcontent-%COMP%]{text-align:left;color:#8e8fa6}"];
export { styles as styles };
